import React from 'react'
import logoImg from '../../assets/logo.png'
export default function RenderLogo ({ showText = true, size=24 }) {
  return <>
    <img src={logoImg} width={`${size}px`} />
    {showText &&
      <span className="font-semibold tracking-tight">Novenya</span>
    }
  </>
}